var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-category-card"},[_vm._t("image"),_c('div',{staticClass:"content"},[_c('div',{staticClass:"big-text"},[_vm._t("name")],2),_c('div',{staticClass:"caption"},[_vm._t("subname")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }